import { gql } from '@apollo/client'

import { DISPLAY_FRAGMENT } from '../fragments'

export const GET_TENANT_DISPLAYS = gql`
  query GetTenantDisplays(
    $filters: DisplayFilter
    $pagination: OffsetPaginationInput
    $order: DisplayOrder
  ) {
    tenantDisplays(filters: $filters, pagination: $pagination, order: $order) {
      results {
        ...Display
      }
      totalCount
    }
  }
  ${DISPLAY_FRAGMENT}
`
